import { DatePicker, DatePickerInput } from "@carbon/react";
import ClassHeader from "../Components/classHeader";
import Header from "../Components/header";
import TeacherHeader from "../Components/teacherHeader";
import DayTimetable from "../Components/dayTimetable";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import { UserEdit } from "../Pages/Admin/users/userEdit";
import { CreateUser } from "../Pages/Admin/users/userCreate";
import HolidayAdd from "../Pages/Admin/holidays/holidayCreate";
import { CreateClass } from "../Pages/Admin/classes/classCreate";
import HolidayManagement from "../Pages/Admin/holidays/holidayManagement";
import { EditClass } from "../Pages/Admin/classes/classEdit";
import UserManagement from "../Pages/Admin/users/userManagement";
import AdminHeader from "../Components/adminHeader";
import GroupsManage from "../Pages/Admin/groups/groupsManage";
import CreateGroup from "../Pages/Admin/groups/groupCreate";
import EditGroup from "../Pages/Admin/groups/groupEdit";
import ClassManagement from "../Pages/Admin/classes/classManagement";
import HolidayEdit from "../Pages/Admin/holidays/holidayEdit";

import AdminDashboard from "../Pages/Admin/AdminDashboard";
import TopicManagement from "../Pages/Admin/topics/topicManagement";
import { CreateTopic } from "../Pages/Admin/topics/topicCreate";
import { TopicEdit } from "../Pages/Admin/topics/topicEdit";


export function AdminLayout(){
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedClass, setSelectedClass] = useState(searchParams.get('class') || null);

    // Update URL when class selection changes
    const handleClassChange = (classId) => {
        setSelectedClass(classId);
        if (classId) {
            setSearchParams({ class: classId });
        } else {
            setSearchParams({});
        }
    };

    // Update state when URL changes (e.g., browser back/forward)
    useEffect(() => {
        const classFromUrl = searchParams.get('class');
        if (classFromUrl !== selectedClass) {
            setSelectedClass(classFromUrl);
        }
    }, [searchParams]);
    return (
    <div className="min-h-screen flex flex-col">
        <Header />
        <TeacherHeader setSelectedClass={handleClassChange} selectedClass={selectedClass} />
        <AdminHeader selectedClass={selectedClass} />

        <section className="flex-1 container mx-auto py-4 px-2">
            <Routes>
                <Route path="/" element={<AdminDashboard selectedClass={selectedClass} />} />
                <Route path="/classes" element={<ClassManagement selectedClass={selectedClass} />} />
                <Route path="/classes/create" element={<CreateClass/>} />
                <Route path="/classes/:uid" element={<EditClass/>} />

                <Route path="/users" element={<UserManagement selectedClass={selectedClass} />} />
                <Route path="/users/create" element={<CreateUser/>} />
                <Route path="/users/:uid" element={<UserEdit/>} />

                <Route path="/holidays" element={<HolidayManagement selectedClass={selectedClass} />} />
                <Route path="/holidays/new" element={<HolidayAdd />} />
                <Route path="/holidays/:id" element={<HolidayEdit />} />

                <Route path="/groups" element={<GroupsManage />} />
                <Route path="/groups/create" element={<CreateGroup />} />
                <Route path="/groups/:id" element={<EditGroup />} />

                <Route path="/topics" element={<TopicManagement />} />
                <Route path="/topics/create" element={<CreateTopic />} />
                <Route path="/topics/:tid" element={<TopicEdit />} />

            </Routes>       
        </section>
        <Footer />
    </div>
    );
}